import { useQuery } from "@tanstack/react-query";
import {
  DispatchBoardQueueLoadDetail,
  GetDispatchBoardQueueLoadDetailsRequest,
} from "app/data/city-delivery/dispatch-board/models";
import CityDeliveryDiaptchBoardService from "app/data/city-delivery/dispatch-board/cityDeliveryDiaptchBoardService";
import { QUERY_KEYS } from "app/data/common/queryKeys";

export const useGetDispatchBoardQueueLoadDetails = (
  requestData: GetDispatchBoardQueueLoadDetailsRequest
) => {
  const hasIdentifier =
    requestData?.terminalNumber &&
    (requestData?.picklistNumber != null || requestData?.manifestNumber != null);

  const {
    data,
    isLoading,
    isFetching,
    isError,
    error,
    isFetched,
    refetch,
  } = useQuery({
    queryKey: [
      QUERY_KEYS.GET_DISPATCH_BOARD_QUEUE_LOAD_DETAILS,
      requestData?.terminalNumber,
      requestData?.picklistNumber,
      requestData?.manifestNumber,
    ],
    queryFn: async () => {
      if (!hasIdentifier) return undefined;
      const response =
        await CityDeliveryDiaptchBoardService.getInstance().getDispatchBoardQueueLoadDetails(
          requestData
        );
      if (response?.ok && !response.ok()) {
        throw response;
      }
      return response?.data;
    },
    enabled: !!hasIdentifier,
    refetchOnMount: "always",
    refetchOnWindowFocus: false,
    retry: true,
  });

  const loadDetails: DispatchBoardQueueLoadDetail[] | undefined =
    data?.loadDetails ??
    (Array.isArray(data) ? (data as unknown as DispatchBoardQueueLoadDetail[]) : undefined);

  return {
    loadDetails,
    isLoadingLoadDetails: isLoading,
    isFetchingLoadDetails: isFetching,
    isErrorLoadDetails: isError,
    errorLoadDetails: error,
    isFetchedLoadDetails: isFetched,
    refetchLoadDetails: refetch,
  };
};
